import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icones-ecodd',
  templateUrl: './icones-ecodd.component.html',
  styleUrls: ['./icones-ecodd.component.css']
})
export class IconesEcoddComponent implements OnInit {
  @Input() text;
  @Input() darkcolor;
  @Input() lightcolor;
  @Input() color;
  @Input() replissage;
  @Input() offsetBlancPourcentage;
  @Input() offsetColorerRemplissage;
  @Input() pourcentageRemplissage;
  @Input() colorerRemplissage;
  @Input() id;

  isGris = false;
  isRouge1 = false;
  isRouge2 = false;
  isRouge = false;

  constructor() { }

  ngOnInit() {
    if (this.replissage) {
      this.colorerRemplissage = this.colorerRemplissage || '#ff0000';
    }

    this.isGris = this.pourcentageRemplissage ? false : true;
    this.isRouge1 = this.pourcentageRemplissage && this.pourcentageRemplissage < 50 ? true : false;
    this.isRouge2 = this.pourcentageRemplissage && this.pourcentageRemplissage >= 50 && this.pourcentageRemplissage < 100 ? true : false;
    this.isRouge = this.pourcentageRemplissage && this.pourcentageRemplissage === 100 ? true : false;
    this.darkcolor = this.darkcolor || '#d9d9d9';
    this.lightcolor = this.darkcolor || '#d9d9d9';
  }

  getIcon(text, offsetBlancPourcentage, offsetColorerRemplissage) {
    if (text === 'fut') {
      return `<svg  xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" id="Calque_1" x="0px" y="0px" width="79.725998"
      height="95.518997" viewBox="0 0 79.725994 95.518996" enable-background="new 0 0 595.28 841.89" xml:space="preserve" sodipodi:docname="fut.svg"
      inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
    
      <defs id="defs706" />
      <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="fut" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
        <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
      </linearGradient>
      <style type="text/css">
        .remplissage1{fill:url(#fut) !important;}
      </style>
    
      <g id="g701" transform="translate(-258.635,-389.032)">
        <g id="g675">
          <rect x="264.99899" y="393.42401" width="67.040001" height="88.486" id="rect673" class="remplissage1" style="fill:#ffffff" />
        </g>
        <g id="g679">
          <rect x="265.08801" y="393.42401" width="14.475" height="88.486" id="rect677"  class="remplissage1" [ngStyle]="{'fill': lightcolor}"/>
        </g>
        <g id="g683">
          <rect x="318.54001" y="393.42401" width="14.458" height="88.486" id="rect681"  class="remplissage1" [ngStyle]="{'fill': lightcolor}"/>
        </g>
        <g id="g687">
          <path d="m 335.732,394.277 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.617 0,-1.456 1.178,-2.628 2.628,-2.628 h 74.469 c 1.445,0 2.629,1.172 2.629,2.628 0,1.444 -1.183,2.617 -2.629,2.617 z"
            id="path685" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
        </g>
        <g id="g691">
          <path d="m 335.732,418.302 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.628 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.455 -1.183,2.628 -2.629,2.628 z"
            id="path689" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
        </g>
        <g id="g695">
          <path d="m 335.732,463.297 h -74.469 c -1.451,0 -2.628,-1.184 -2.628,-2.629 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.445 -1.183,2.629 -2.629,2.629 z"
            id="path693" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
        </g>
        <g id="g699">
          <path d="m 335.732,484.551 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.641 0,-1.443 1.178,-2.617 2.628,-2.617 h 74.469 c 1.445,0 2.629,1.174 2.629,2.617 0,1.469 -1.183,2.641 -2.629,2.641 z"
            id="path697" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
        </g>
      </g>
    </svg>`;
    }

    if (text === 'bac') {
      return `
      <svg *ngIf="text === 'bac'" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="103.74004" height="136.80499"
  viewBox="0 0 103.74003 136.80499" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg3825" sodipodi:docname="bac.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
 
  <defs id="defs3829" />
  <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="bac" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
    <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
  </linearGradient>
  <style type="text/css">
    .remplissage2{fill:url(#bac) !important;}
  </style>

  
  <g id="Calque_3" class="remplissage2" transform="translate(-237.59583,-338.338)">
    <path d="m 241.728,469.598 c 0,2.037 1.656,3.697 3.697,3.697 v 0 c 2.044,0 3.7,-1.66 3.7,-3.697 v -15.621 c 0,-2.045 -1.656,-3.697 -3.7,-3.697 v 0 c -2.041,0 -3.697,1.652 -3.697,3.697 z"
      id="path3808" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': darkcolor}"/>
    <path d="m 329.682,469.598 c 0,2.037 1.656,3.697 3.697,3.697 v 0 c 2.045,0 3.701,-1.66 3.701,-3.697 v -15.621 c 0,-2.045 -1.656,-3.697 -3.701,-3.697 v 0 c -2.041,0 -3.697,1.652 -3.697,3.697 z"
      id="path3810" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': darkcolor}"/>
    <g id="g3822">
      <g id="g3820">
        <path d="m 241.282,347.898 h 96.37 c 0.879,0 1.615,0.728 1.615,1.627 v 7.116 c 0,0.875 -0.736,1.603 -1.615,1.603 h -96.37 c -0.888,0 -1.632,-0.728 -1.632,-1.603 v -7.116 c 0,-0.899 0.745,-1.627 1.632,-1.627 z"
          id="path3812" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': darkcolor}"/>
        <path d="m 250.859,475.143 h 77.199 c 0.834,0 1.537,-0.662 1.603,-1.513 l 6.253,-113.651 c 0.024,-0.458 -0.114,-0.875 -0.43,-1.211 -0.327,-0.335 -0.724,-0.523 -1.186,-0.523 h -89.663 c -0.475,0 -0.876,0.188 -1.194,0.523 -0.311,0.336 -0.445,0.753 -0.43,1.211 l 6.253,113.651 c 0.062,0.85 0.754,1.513 1.595,1.513 z"
          id="path3814" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  />
        <path d="m 341.107,346.034 c -1.574,-2.748 -4.519,-4.596 -7.889,-4.596 h -87.512 c -3.361,0 -6.311,1.848 -7.885,4.596 -0.303,0.532 -0.303,1.162 0.017,1.701 0.307,0.548 0.839,0.859 1.477,0.859 h 100.291 c 0.63,0 1.17,-0.311 1.489,-0.859 0.311,-0.54 0.327,-1.17 0.012,-1.701 z"
          id="path3816" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': lightcolor}"/>
        <path d="m 330.786,341.438 c -1.342,-1.865 -3.513,-3.1 -5.958,-3.1 h -70.73 c -2.437,0 -4.637,1.235 -5.949,3.1 z"
          id="path3818" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': darkcolor}"/>
      </g>
    </g>
  </g>
</svg>`;
    }

    if (text === 'benne') {
      return `
      <svg  xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="117.81" height="52.928001"
  viewBox="0 0 117.80999 52.928" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg3791" sodipodi:docname="bennes.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
  <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="benne" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
    <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
  </linearGradient>
  <style type="text/css">
    .remplissage3{fill:url(#benne) !important;}
  </style>

  <defs id="defs3795" />
  
  <g id="Calque_2" class="remplissage3" transform="translate(-238.077,-404.399)">
    <g id="g3784">
      <path d="m 250.199,453.438 c 0,2.137 1.751,3.889 3.878,3.889 h 84.552 c 2.131,0 3.883,-1.752 3.883,-3.889 l 9.684,-41.906 h -110.65 z"
        id="path3780" inkscape:connector-curvature="0" class="remplissage"  />
      <path d="M 354.076,404.399 H 239.935 c -1.053,0 -1.858,0.483 -1.858,1.085 v 4.952 c 0,0.612 0.806,1.096 1.858,1.096 h 1.611 110.649 1.881 c 1.004,0 1.811,-0.483 1.811,-1.096 v -4.952 c 0,-0.602 -0.807,-1.085 -1.811,-1.085 z"
        id="path3782" inkscape:connector-curvature="0"  [ngStyle]="{'fill': offsetColorerRemplissage === 100 ? '#ff0000' : darkcolor}" />
    </g>
    <rect x="256.28699" y="407.39099" width="5.1989999" height="10.57" id="rect3786" style="fill:#ffffff" />
    <rect x="333.13699" y="407.39099" width="5.1989999" height="10.57" id="rect3788" style="fill:#ffffff" />
  </g>
</svg>
      `;
    }

    if (text === 'caissepalette') {
      return `
      <svg  xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="167.46201" height="89.875"
  viewBox="0 0 167.462 89.874998" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg458" sodipodi:docname="caissepalette.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
  <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="caissepalette" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
    <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
  </linearGradient>
  <style type="text/css">
    .remplissage5{fill:url(#caissepalette) !important;}
  </style>
  <defs id="defs462" />
  <g id="Calque_4" class="remplissage5" transform="translate(-210.5,-390.153)">
    <g id="g388">
      <polygon points="217.625,399.698 217.625,399.832 217.42,399.832 217.42,480.028 237.231,480.028 237.231,468.364 237.317,468.364 237.317,406.938 286.711,406.938 286.711,468.431 286.708,468.431 286.708,480.028 301.546,480.028 301.546,468.364 301.557,468.364 301.557,406.938 350.94,406.938 350.94,468.431 350.836,468.431 350.836,479.835 370.64,479.835 370.64,399.832 370.543,399.832 370.543,399.698 "
        id="polygon382"  />
      <polygon points="237.317,468.364 237.317,468.431 286.708,468.431 286.711,468.431 286.711,406.938 237.317,406.938 "
        id="polygon384"  />
      <polygon points="301.557,468.364 301.557,468.431 350.836,468.431 350.94,468.431 350.94,406.938 301.557,406.938 " id="polygon386"/>
    </g>
    <path d="m 213.235,390.153 h 162.009 c 1.473,0 2.718,0.84 2.718,1.866 v 8.2 c 0,1.01 -1.245,1.843 -2.718,1.843 H 213.235 c -1.483,0 -2.735,-0.833 -2.735,-1.843 v -8.2 c 0,-1.026 1.252,-1.866 2.735,-1.866 z"
      id="path390" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': offsetColorerRemplissage === 100 ? '#ff0000' : darkcolor}"/>
  </g>
</svg>
      `;
    }
    if (text === 'groupe') {
      return `
      <svg  xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="239.582" height="118.403"
  viewBox="0 0 239.58199 118.403" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg988" sodipodi:docname="groupe.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
  <defs id="defs992" />
  <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="groupe" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
    <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
  </linearGradient>
  <style type="text/css">
    .remplissage6{fill:url(#groupe) !important;}
  </style>
  <g id="Calque_7" class="remplissage6" transform="translate(-165.225,-402.989)">
    <g id="g939">
      <path d="m 226.086,485.922 c 0,3.603 2.959,6.574 6.558,6.574 h 142.982 c 3.603,0 6.562,-2.972 6.562,-6.574 l 16.377,-70.863 H 211.452 Z"
        id="path935" inkscape:connector-curvature="0"   />
      <path d="M 401.748,402.989 H 208.729 c -1.781,0 -3.142,0.813 -3.142,1.843 v 8.367 c 0,1.037 1.361,1.859 3.142,1.859 h 2.723 187.112 3.184 c 1.697,0 3.059,-0.822 3.059,-1.859 v -8.367 c 0,-1.029 -1.362,-1.843 -3.059,-1.843 z"
        id="path937" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
    </g>
    <g id="g969">
      <g id="g943">
        <rect x="170.923" y="436.43301" width="60.043999" height="79.248001" id="rect941"  />
      </g>
      <g id="g947">
        <rect x="171.006" y="436.43301" width="12.962" height="79.248001" id="rect945"  />
      </g>
      <g id="g951">
        <rect x="218.881" y="436.43301" width="12.949" height="79.248001" id="rect949"  />
      </g>
      <g id="g955">
        <path d="m 234.275,437.196 h -66.696 c -1.299,0 -2.354,-1.054 -2.354,-2.341 0,-1.312 1.054,-2.357 2.354,-2.357 h 66.696 c 1.299,0 2.354,1.046 2.354,2.357 -0.001,1.288 -1.055,2.341 -2.354,2.341 z"
          id="path953" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
      </g>
      <g id="g959">
        <path d="m 234.275,458.712 h -66.696 c -1.299,0 -2.354,-1.046 -2.354,-2.357 0,-1.303 1.054,-2.349 2.354,-2.349 h 66.696 c 1.299,0 2.354,1.046 2.354,2.349 -0.001,1.311 -1.055,2.357 -2.354,2.357 z"
          id="path957" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
      </g>
      <g id="g963">
        <path d="m 234.275,499.013 h -66.696 c -1.299,0 -2.354,-1.062 -2.354,-2.357 0,-1.304 1.054,-2.35 2.354,-2.35 h 66.696 c 1.299,0 2.354,1.046 2.354,2.35 -0.001,1.294 -1.055,2.357 -2.354,2.357 z"
          id="path961" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
      </g>
      <g id="g967">
        <path d="m 234.275,518.046 h -66.696 c -1.299,0 -2.354,-1.046 -2.354,-2.365 0,-1.295 1.054,-2.341 2.354,-2.341 h 66.696 c 1.299,0 2.354,1.046 2.354,2.341 -0.001,1.319 -1.055,2.365 -2.354,2.365 z"
          id="path965" inkscape:connector-curvature="0"  [ngStyle]="{'fill': darkcolor}"/>
      </g>
    </g>
    <path d="m 248.943,517.656 c 0,1.378 1.112,2.49 2.486,2.49 v 0 c 1.378,0 2.495,-1.112 2.495,-2.49 v -10.518 c 0,-1.369 -1.117,-2.481 -2.495,-2.481 v 0 c -1.374,0 -2.486,1.112 -2.486,2.481 z"
      id="path971" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': lightcolor}"/>
    <path d="m 308.152,517.656 c 0,1.378 1.117,2.49 2.49,2.49 v 0 c 1.374,0 2.49,-1.112 2.49,-2.49 v -10.518 c 0,-1.369 -1.116,-2.481 -2.49,-2.481 v 0 c -1.373,0 -2.49,1.112 -2.49,2.481 z"
      id="path973" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd"  [ngStyle]="{'fill': lightcolor}"/>
    <g id="g985">
      <g id="g983">
        <path d="m 248.64,435.728 h 64.88 c 0.589,0 1.087,0.489 1.087,1.096 v 4.798 c 0,0.581 -0.498,1.079 -1.087,1.079 h -64.88 c -0.598,0 -1.096,-0.498 -1.096,-1.079 v -4.798 c 0,-0.607 0.498,-1.096 1.096,-1.096 z"
          id="path975" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill:#ffffff;fill-rule:evenodd" />
        <path d="m 255.089,521.392 h 51.972 c 0.56,0 1.033,-0.448 1.079,-1.021 l 4.208,-76.508 c 0.017,-0.308 -0.079,-0.59 -0.29,-0.813 -0.221,-0.225 -0.486,-0.349 -0.797,-0.349 h -60.364 c -0.32,0 -0.589,0.124 -0.801,0.349 -0.211,0.224 -0.303,0.506 -0.29,0.813 l 4.208,76.508 c 0.042,0.572 0.507,1.021 1.075,1.021 z"
          id="path977" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd" />
        <path d="m 315.844,434.474 c -1.059,-1.851 -3.043,-3.096 -5.309,-3.096 H 251.62 c -2.262,0 -4.246,1.245 -5.309,3.096 -0.203,0.357 -0.203,0.78 0.013,1.146 0.208,0.374 0.564,0.581 0.992,0.581 h 67.519 c 0.423,0 0.784,-0.207 1,-0.581 0.212,-0.366 0.22,-0.789 0.009,-1.146 z"
          id="path979" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd" [ngStyle]="{'fill': darkcolor}"/>
        <path d="m 308.896,431.378 c -0.904,-1.254 -2.365,-2.084 -4.009,-2.084 h -47.619 c -1.639,0 -3.121,0.83 -4.005,2.084 z"
          id="path981" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill:#ffffff;fill-rule:evenodd" />
      </g>
    </g>
  </g>
</svg>
      `;
    }
    if (text === 'tas') {
      return `
      <svg   xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="232.496" height="85.824997"
  viewBox="0 0 232.49599 85.824995" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg1168" sodipodi:docname="tas.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
  <linearGradient *ngIf="replissage" xmlns="http://www.w3.org/2000/svg" id="tas" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="${offsetBlancPourcentage}" style="stop-color: #d9d9d9;stop-opacity:1;"/>
    <stop offset="${offsetColorerRemplissage}" style="stop-color: #ff0000 ;stop-opacity:1;"/>
  </linearGradient>
  <style type="text/css">
    .remplissage7{fill:url(#tas) !important;}
  </style>
  <defs id="defs1172" />
  
  <g id="Calque_6" transform="translate(-173.303,-422.376)" class="remplissage7">
    <path d="m 397.285,500.638 -2.086,-4.989 0.037,0.009 -0.106,-0.18 -8.53,-20.406 c 0,0 -4.188,-6.281 -9.77,-2.789 -0.736,0.458 -1.292,0.785 -1.738,1.022 -0.605,-0.441 -1.219,-0.858 -1.856,-1.227 -0.188,-1.039 -0.572,-2.445 -1.987,-3.983 -3.926,-4.269 -6.281,-15.352 -6.281,-15.352 l -10.992,-0.883 -5.496,3.402 -0.646,1.521 -0.4,-3.353 -2.355,-2.355 -4.711,0.262 -0.396,1.742 c -0.888,-0.467 -1.73,-1.047 -2.654,-1.399 -0.793,-3.402 -2.388,-6.984 -5.324,-3.287 l -2.695,-1.767 -0.744,0.024 6.928,-6.126 9.512,-13.258 -23.702,13.528 c -0.192,-4.426 0.086,-5.66 -9.974,-7.778 -13.262,-2.789 -19.629,-0.523 -27.742,-2.094 -1.472,-0.286 -0.699,9.16 -6.281,2.879 -2.928,-3.288 -4.429,-4.613 -6.956,-1.832 -0.989,-0.843 -2.507,-0.613 -4.155,0.139 l -1.452,-1.447 -4.711,0.262 -0.491,2.159 -17.13,-10.706 -4.188,6.977 14.509,12.832 -0.552,0.434 -3.227,4.016 -3.316,-6.551 -3.402,0.262 -10.992,0.883 c 0,0 -2.355,11.083 -6.281,15.352 -2.021,2.2 -1.971,4.146 -2.196,5.062 -0.11,0.164 -0.217,0.319 -0.327,0.483 -0.376,0.188 -1.137,-0.156 -3.059,-1.358 -5.582,-3.492 -9.77,2.789 -9.77,2.789 l -7.562,12.604 c -8.428,5.685 -16.365,16.733 -28.735,31.528 h 122.153 l 110.343,0.442 c -3.186,-2.61 -5.979,-5.113 -8.514,-7.493 z"
      id="path1163" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd" />
    <path d="m 360.984,483.062 c -2.426,-9.038 -10.285,-13.635 -17.613,-12.089 l -0.998,-0.802 -2.445,-4.188 -2.041,-1.047 -4.895,1.047 c 0,0 0,0 -3.268,-2.617 l -1.631,-1.57 -7.346,1.57 -0.813,-2.094 -2.449,-0.523 h -3.673 l -6.052,0.704 -2.311,-3.583 -2.449,2.617 -8.158,-14.133 -2.854,0.523 -2.245,11.254 -4.895,-1.047 -6.531,10.992 -1.223,4.188 -3.292,-6.788 -2.421,5.218 -7.353,5.071 -0.401,3.827 h -4.077 l -1.631,1.047 -2.041,6.805 -3.672,0.523 -6.531,0.523 -0.814,9.422 -11.017,9.945 158.254,0.344 c -21.635,-11.153 -22.473,-29.727 -31.114,-25.139 z"
      id="path1165" inkscape:connector-curvature="0" style="clip-rule:evenodd;fill-rule:evenodd" />
  </g>
</svg>
      `;
    }

  }

}
